export default "__VITE_ASSET__BZRt8NCG__"